<template>
    <div>
        <div style="margin-top: 15px" v-for="(item,index) in orderList" :key="index">
            <div style="box-shadow: 1px 1px 4px #999999; font-size: 14px; padding: 10px">
                <div slot="head"></div>
                <PddOrderInfoCard_With_Img
                        :order-info-data="item"
                        @topClick="showOrderDetail(item)"
                ></PddOrderInfoCard_With_Img>
            </div>
        </div>
        <van-action-sheet v-model="show" title="订单详情" style="padding-bottom: 20px" :round="false">

            <PddOrderDetail
                    :goodsWholeInfo="goodsWholeInfo"
            ></PddOrderDetail>
        </van-action-sheet>
    </div>
</template>

<script>
    import PddOrderInfoCard_With_Img from "../custom/PddOrderInfoCard_With_Img";
    import PddOrderDetail from "../custom/PddOrderDetail";

    export default {
        name: "Wp_pdd_order_list",
        components: {PddOrderDetail, PddOrderInfoCard_With_Img},
        props: {
            orderList: {
                type: Array,
                default: null
            },

        },
        data() {
            return {
                show: false,
                orderInfoData: null,
                goodsWholeInfo: null,
            }
        },
        methods: {
            /**
             * 显示商品详情（小程序使用）
             */
            showSkuDetail(item){
                let skuId = item.skuList[0].skuId;
                if(skuId){
                    this.navigateToDetail(skuId);
                }
            },

            /**
             * 打开小程序中的详情界面
             */
            navigateToDetail(sku_str) {
                this.$common.navigateToMiniProgramPage("../wp_detail/wp_detail?", "skuId", sku_str);
            },


            /**
             * 显示订单详情
             */
            showOrderDetail(item) {
                this.show = true;
                this.goodsWholeInfo = item;
            },
        }
    }
</script>

<style scoped>

</style>
